


































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { namespace } from 'vuex-class';
import { NAMESPACE } from '@/store/models/work/enterprise/customers';
import { NAMESPACE as P_NAMESPACE } from '@/store/models/work/enterprise/positions';
import Pagination from '@/components/Pagination.vue';
import { PageMeta } from '@/types/pagination';
import { Watch } from 'vue-property-decorator';
import { GET_ITEMS, ITEMS_REQUEST, META, LOADING } from '@/store';
import { CustomerModel } from '@/store/types/work/Providers';
import CustomerItem from '@/components/work/customers/Item.vue';
import CustomersReport from '@/components/work/customers/report.vue';
import CustomersMapComponent from '@/components/work/customers/CustomersMapComponent.vue';

const customersStore = namespace(NAMESPACE);
const positionsStore = namespace(P_NAMESPACE);

@Component({
  components: { CustomersMapComponent, Pagination, CustomerItem, CustomersReport }
})
export default class CustomersIndex extends Mixins<SlotMixin>(SlotMixin) {
  @customersStore.Getter(LOADING) loading!:boolean;
  @customersStore.Getter(GET_ITEMS) customers!:CustomerModel[];
  @customersStore.Getter(META) meta!:PageMeta;

  @customersStore.Action(ITEMS_REQUEST) customersRequest: any;

  @positionsStore.Action(ITEMS_REQUEST) positionsRequest: any;
  @positionsStore.Getter(GET_ITEMS) positions!:any[];

  @Watch('$route.query')
  public onQueryChange () {
    this.setFilters();
  }

  showDialog = false;
  public mapDialog = false;

  public fab = false;

  public filter = {
    manager_id: null
  };

  setFilters () {
    this.customersRequest({
      filters: { ...this.filter },
      per_page: 30,
      with: ['lastOutgoingInvoice'],
      ...this.$route.query
    });
  }

  created () {
    this.positionsRequest();
    this.customersRequest({
      filters: { ...this.filter },
      per_page: 30,
      with: ['lastOutgoingInvoice'],
      ...this.$route.query
    });
    this.$gtag.event('page_view', { event_label: 'Перегляд замовників' });
  }
}
